import { Injectable } from '@angular/core';
import { BaseService } from '../base/util/base.service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { URL_GERAR_PROTOCOLO, URL_ENVIAR_CONVERSA, URL_REGISTRAR_CONVERSA } from '../base/util/url-util';

@Injectable()
export class ChatbotService extends BaseService {

  // private apiUrl = "http://server-unimed-odonto-dev.mybluemix.net/api/message";

  constructor(public http: HttpClient,public messageService: MessageService) { 
      super(http,messageService);
  }

  public gerarProtocolo() {
    return this.get(URL_GERAR_PROTOCOLO);
  }

  public enviarMensagem(context, mensagem){
    const mensagemObj = {context, input: {text: mensagem}};    
    return this.post(URL_ENVIAR_CONVERSA, mensagemObj);
  }

  public registrarConversa(numeroProtocolo, texto){
    const conversaObj = {numeroProtocolo: numeroProtocolo, texto: texto};    
    return this.post(URL_REGISTRAR_CONVERSA, conversaObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/chatbot/chatbot.service.ts